import React from 'react';
import { useTranslation } from 'react-i18next';
import { PencilSquareIcon, XCircleIcon } from '@heroicons/react/24/outline';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ar';
import Modal from '../../shared/components/UI/Modal';
import CancelModal from './CancelModal';
import EditModal from './EditModal';

const ModalEditCancel = ({ shown, close, order }) => {
  const { t, i18n } = useTranslation();
  const [modalShowCancel, toggleModalShowCancel] = React.useState(false);
  const [modalShowEdit, toggleModalShowEdit] = React.useState(false);

  const refundDate = moment((order.date ?? order.date_depart_activity) + ' 12:00')
    .locale(i18n.language)
    .format('LL');

  return (
    <>
      <Modal
        shown={shown}
        close={close}
        size="modal--small"
        title={t('account.manageTitle')}
        subtitle={t('account.manageSubtitle', { date: refundDate })}
      >
        <div className="space-y-3">
          <button
            type="button"
            onClick={() => {
              toggleModalShowEdit(true);
              close();
            }}
            className="flex w-full items-center justify-center gap-2 rounded-xl border border-slate-200 px-4 py-3 text-sm font-semibold text-ink transition-colors hover:border-brand-500 hover:text-brand-500"
          >
            <PencilSquareIcon className="h-4 w-4" />
            {t('account.manageModify')}
          </button>
          <button
            type="button"
            onClick={() => {
              toggleModalShowCancel(true);
              close();
            }}
            className="flex w-full items-center justify-center gap-2 rounded-xl border border-rose-200 px-4 py-3 text-sm font-semibold text-rose-600 transition-colors hover:bg-rose-50"
          >
            <XCircleIcon className="h-4 w-4" />
            {t('account.manageCancel')}
          </button>
        </div>
      </Modal>

      <CancelModal order={order} shown={modalShowCancel} close={() => toggleModalShowCancel(false)} />
      <EditModal order={order} shown={modalShowEdit} close={() => toggleModalShowEdit(false)} />
    </>
  );
};

export default ModalEditCancel;
